import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationCancel } from '@angular/router';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject, takeUntil } from 'rxjs';
import { TitleService } from '../../shared/services/title.service';
import { BeneficiariesService } from '../../shared/services/beneficiaries.service';
import { BeneficiaryDto } from '../dto/beneficiary.dto';

@Component({
  selector: 'app-rsj-details',
  templateUrl: './rsj-details.component.html',
  providers: [NgbNav],
  standalone: false,
})
export class RsjDetailsComponent implements OnInit, OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();
  public activeTabId: string = 'rsj-personaldata';
  public beneficiary: BeneficiaryDto;
  public id: number;

  constructor(
    private readonly titleService: TitleService,
    private readonly beneficiaryService: BeneficiariesService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationCancel),
        takeUntil(this.destroy$),
      )
      .subscribe(() => (this.activeTabId = this.route.firstChild.routeConfig.path));
  }

  public async ngOnInit(): Promise<void> {
    this.id = +this.route.snapshot.paramMap.get('id');
    this.beneficiary = await this.beneficiaryService.findById(this.id);
    if (this.beneficiary) {
      this.titleService.setTitle('Parcours RSJ de ' + this.beneficiary.firstName + ' ' + this.beneficiary.usualName);

      this.beneficiaryService.beneficiary.setValue(this.beneficiary);
      if (this.route.firstChild.routeConfig.path) {
        this.activeTabId = this.route.firstChild.routeConfig.path;
      }
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onNavChange(event: NgbNavChangeEvent): void {
    this.router.navigate([event.nextId], { relativeTo: this.route });
    this.activeTabId = event.nextId;
  }
}
